<template>
    <div>
        <BreadCrumb :data="breadCrumb" /> 
        <b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>

        <b-card v-else no-body class="formGroup" >
            <b-tabs pills card :value="activeIndex">
                <b-tab :title="$t('customer.wizzard.stepName1')" @click="pageSettings([false, true], 'Customer', 0)">
                    <b-card-text style="padding: 1rem;">
                        <Form ref="InformationForm" :loading="loading" :data="customerData" :forms="InformationForm" :customField="customerData.custom_fields" />
                    </b-card-text>
                </b-tab>
                <b-tab :title="$t('customer.wizzard.addressHead')"  @click="pageSettings([true, false], 'CustomerAddresses', 1)">
                    <b-card-text>
                        <Addresses :modalType="pageSettings" ref="Addresses"  :modalEvent="openModal" :data="addresses"  />
                    </b-card-text>
                </b-tab>
                <b-tab :title="$t('customer.wizzard.stepName4')" @click="pageSettings([false, true], 'Dealer', 2)">
                    <b-card-text>
                        <Dealers ref="Dealers"  :modalEvent="openModal" :data="companies"  />
                    </b-card-text>
                </b-tab>
                <b-tab :title="$t('customer.wizzard.stepName2')" @click="pageSettings([true, false ], 'CustomerUser', 3)">
                    <b-card-text>
                        <Users ref="Users"  :modalEvent="openModal" :data="users"  />
                    </b-card-text>
                </b-tab>
                <b-tab :title="$t('customer.wizzard.stepName5')" @click="pageSettings([true, false], 'RemoteUser', 4)"> 
                    <b-card-text >
                        <RemoteUser type="edit" :customer="{data: this.$route.params.id}"  />
                    </b-card-text>
                </b-tab>
                <b-tab :title="$t('customer.wizzard.stepName3')" @click="pageSettings([true, false], 'CustomerSubscription', 5)"> 
                    <b-card-text >
                        <Subscription type="edit" :customer="{data: this.$route.params.id}"  />
                    </b-card-text>
                </b-tab>
            </b-tabs>

            <template v-slot:footer class="footer">
                <div class="customerState"> 
                    <span v-if="customerData.active == 1">
                        <b-alert variant="success" show>
                            <b-icon icon="check" animation="throb" font-scale="1.5" ></b-icon>
                            <span > {{$t('account.active')}}  </span>
                        </b-alert>
                    </span>
                    <span v-else-if="customerData.active == 2">
                        <b-alert variant="danger" show>
                            <b-icon icon="x" animation="throb" font-scale="1.5" ></b-icon>
                            <span > {{$t('account.cancel')}} - {{$t('account.cancelMsg')}} </span>
                        </b-alert>           
                    </span>
                    <span v-else>
                        <b-alert variant="warning" show>
                            <b-icon icon="exclamation-triangle-fill" animation="throb" font-scale="1.5" ></b-icon>
                            <span > {{$t('general.passife')}} - {{$t('account.passifeMsg')}} </span>
                        </b-alert>                                
                    </span>
                </div>
                <div>
                    <b-button variant="success" v-if="newButton" @click="openModal(true, 'add' )">{{$t('general.add')}}</b-button>
                    <b-button variant="primary" v-else-if="saveButton" @click="saveData">{{$t('general.save')}}</b-button>
                </div>
            </template>
            
        </b-card>
         <!-- Modals -->
        <Modals :open="modalOpen" :modalEvent="openModal" :modalProps="modalProps" :form="currentForm" :modalName="modalName" />
    </div>
</template>

<script>
    import BreadCrumb from '@/components/BreadCrumb'
    import Addresses from './components/Addresses'
    import UserForm from './components/UserForm'
    import Users from './components/Users'
    import Dealers from './components/Dealers'
    import Subscription from './components/Subscribtion'
    import Product from './components/Product.vue'
    import RemoteUser from './components/RemoteUser'
    import Modals from "./modals/"
    import i18n from '@/plugins/i18n';
    import Form from '@/components/Form'
    import Forms from './forms'
    import {prepareRequestData, setFormData} from '@/assets/js/custom.js'

    let breadCrumb = [
        { label: i18n.t('pages.customer.name'), url: "/Customer/List" },
    ]
    export default {
        name: "CustomerEdit",
        created: async function(){
            await this.$store.dispatch('getCustomerDetail', {id: this.$route.params.id})
            this.$store.dispatch('listFormsCustomFields', 'CST' )
            this.pageSettings([false, true], 'Customer')
        },
         computed: {
            loading(){
                return this.$store.getters.getLoading
            },
            customerData(){
                this.breadCrumb = [
                    { label: i18n.t('pages.customer.name'), url: "/Customer/List" },
                    { label: this.$store.getters.getCustomerData.name, url: "/Customer/"+this.$route.params.id },
                    { label: i18n.t('pages.customer.edit'), url: "/Customer/"+this.$route.params.id }
                ]
                return this.$store.getters.getCustomerData
            },
            customField(){
                return this.$store.getters.getFormCustomFields
            },
            addresses(){
                return this.$store.getters.getCustomerAddresses
            },
            users(){
                return this.$store.getters.getCustomerContacts
            },
            companies(){
                return this.$store.getters.getCustomerCompany
            }
        },
        data: function(){
            return {
                breadCrumb, modalOpen: false, modalProps: {}, currentForm:null, modalName: null, newButton: false, saveButton: true,
                InformationForm: Forms.InformationForm, 
                activeIndex: 0,
                otherTab:"",
            }
        },
        components:{ BreadCrumb, Form, UserForm, Subscription, Product, Modals, Addresses, Users, RemoteUser, Dealers },
        methods:{
            openModal: function(state, modal, props){
               this.modalOpen = state
                if(state){
                    this.modalProps = props
                    this.modalName = modal
                }
            },
            pageSettings: async function(state, form, index){
                this.newButton = state[0]
                this.saveButton = state[1]
                this.currentForm = form
                this.activeIndex = index
                let params = {parent_id: this.$route.params.id}
                switch(form){
                    case 'Dealer':
                        await this.$store.dispatch('getCustomerCompany', {id: this.$route.params.id})
                        break;
                }
                await this.$store.dispatch((form+'_get').toLowerCase(), params)
            },
            saveData: async function(){
                switch(this.currentForm){
                    case "Customer":
                        this.$refs.InformationForm.$refs.Form.validate().then(success =>{
                            if(success){
                                let data =  prepareRequestData(this.InformationForm, this.$refs.InformationForm.formData)
                                let cf = []
                                console.log(this.customerData.custom_fields)
                                this.customerData.custom_fields && this.customerData.custom_fields.map(custom => {
                                    cf.push({
                                       custom_field_id: custom.id,
                                       value: custom.field_value.value
                                    })
                                })
                                data.custom_fields = cf
                                data.id =  parseInt(this.$route.params.id)
                                this.$store.dispatch('customerInfo_edit', data)
                            }else{
                                return false
                            }
                        })
                        
                        break;
                    case "Dealer":
                        let data ={
                            customerId: this.$route.params.id,
                            company_info: [ ]
                        }
                        this.$refs.Dealers.hasCompanies.map(hc => {
                            console.log(hc)
                            data.company_info.push({
                                "company_id": hc.info.id,
                                "is_technical_service": hc.info.is_technical_service || hc.is_technical_service 
                            })
                        })
                        await this.$store.dispatch('setCustomerCompany', data)
                        await this.$store.dispatch('getCustomerCompany', {id: this.$route.params.id})
                        break;
                }
            }
        }
        
    }
</script>

<style lang="css" scoped> 
    @import "./styles/add.min.css"; 
</style>


// WEBPACK FOOTER //
// src/pages/General/Customer/Edit.vue